import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt';

import { birdToast } from '../../../shared/components/core-ui/toast';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import Select, { ValueType } from 'react-select';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import EditIcon from '@material-ui/icons/Edit';
import BathtubIcon from '@material-ui/icons/Bathtub';
import { Button as MIButton } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Switch from '@material-ui/core/Switch';
import { orange } from '@material-ui/core/colors';
import DeleteIcon from '@material-ui/icons/Delete';
import { ErrorInfo, isErrorInfo } from '../../../shared/interfaces/error-info.interface';
import { trackPage } from '../../../shared/services/utils/tracking/tracking.service';
import { AddUnitTypeModal } from './components/add-unit-type-modal/add-unit-type-modal.component';
import { DeleteUnitTypeModal } from './components/delete-unit-type-modal/delete-unit-type-modal.component';
import {
  UnitTypeUiModel,
  UnitTypeUiModelResponse,
  RoomsUiModelResponse
} from '../../../shared/ui-models/unit-type.ui-model';
import { APP_ROUTES, PUBLIC_PATH } from '../../../shared/config/routes-config';
import { useHistory } from 'react-router';
import { RouteConfig } from '../../../shared/interfaces/routes-config.interface';
import useWindowResizer from '../../../shared/hooks/window-resizer/window-resizer.hook';
import { getModuleName } from '../../shared/services/unit-type.service';
import {
  addNewUnitType,
  getAllUnitTypes,
  getUnitTypeRooms
} from '../../../shared/services/data/unit-type.data';
import { InputText } from '../../../shared/components/core-ui/input-text/input-text.component';
import { FormElementData } from '../../../shared/interfaces/form-element-data.interface';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../shared/components/core-ui/button/button.component';
import { withStyles } from '@material-ui/core/styles';
import StarBorderOutlined from '@material-ui/icons/StarBorderOutlined';
import Star from '@material-ui/icons/Star';
import { updateUnitTypeData } from '../../shared/services/data.service';
import { ReservationMode } from '../../../shared/enums/reservation-mode.enum';
import WarningIcon from '@material-ui/icons/Warning';
import { BookingMode } from '../../../shared/enums/booking-mode.enum';
import { Pagination } from '../../../shared/components/core-ui/pagination/pagination.component';
import Tooltip from '../../../ui/Tooltip';
import { LoadingData } from '../../../ui/LoadingData';
import { cn } from '../../../utils/cn';

const OrangeSwitch = withStyles({
  switchBase: {
    // color: orange[300],
    '&$checked': {
      color: orange[500]
    },
    '&$checked + $track': {
      backgroundColor: orange[500]
    }
  },
  checked: {},
  track: {}
})(Switch);

const UnitTypesListContainer = () => {
  const formatPriceValue = (value?: number) => {
    const numericValue = Number(value || 0);
    return Number.isFinite(numericValue) ? numericValue.toLocaleString() : '0';
  };

  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [unitTypesList, setUnitTypesList] = useState<UnitTypeUiModel[]>([]);
  const [intialUnitTypesList, setIntialUnitTypesList] = useState<UnitTypeUiModel[]>([]);
  const [roomsOptions, setRoomsOptions] = useState<{ value: string; label: string }[]>([]);
  const [publishedOptions] = useState<{ value: boolean; label: string }[]>([
    {
      value: true,
      label: 'Published'
    },
    {
      value: false,
      label: 'Unpublished'
    }
  ]);
  const [featuredOptions] = useState<{ value: boolean; label: string }[]>([
    {
      value: true,
      label: 'Featured'
    },
    {
      value: false,
      label: 'Unfeatured'
    }
  ]);
  const [channelManagerOptions] = useState<{ value: boolean; label: string }[]>([
    {
      value: true,
      label: 'Synced'
    },
    {
      value: false,
      label: 'Not Synced'
    }
  ]);

  const isMobileView = useWindowResizer();
  const [roomId, setRoomId] = useState<string>();
  const [publishedSelected, setPublishedSelected] = useState<boolean | undefined>();
  const [featuredSelected, setFeaturedSelected] = useState<boolean | undefined>();
  const [channelManagerSelected, setChannelManagerSelected] = useState<boolean | undefined>();
  const [unitTypeSearch, setUnitTypeSearch] = useState<FormElementData<string>>({
    value: '',
    isValid: true
  });
  const [updatingUnit, setUpdatingUnit] = useState<boolean>(false);
  const history = useHistory();
  const { t } = useTranslation();
  const [listCount, setListCount] = useState<number>(0);
  const [offset, setOffset] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchQuery, setSearchQuery] = useState<any>({});
  const [filtersOpen, setFiltersOpen] = useState<boolean>(false);

  const reInitialize = () => {
    setOffset(1);
    setRoomId('');
    setPublishedSelected(undefined);
    setFeaturedSelected(undefined);
    setChannelManagerSelected(undefined);
    setSearchQuery({});
    setUnitTypeSearch({ value: '', isValid: true });
  };
  const getAllRooms = () => {
    getUnitTypeRooms(getModuleName()).then((response: RoomsUiModelResponse[] | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        setRoomsOptions(response);
        setLoadingData(false);
      } else {
        birdToast.error('error while getting rooms', 'failed loading unit type rooms');
      }
    });
  };
  useEffect(() => {
    trackPage('unit-types-list');
    reInitialize();
    setLoadingData(true);

    getAllUnitTypes(getModuleName(), offset, limit, searchQuery).then(
      (response: UnitTypeUiModelResponse | ErrorInfo) => {
        if (!isErrorInfo(response)) {
          setListCount(response?.count);
          setUnitTypesList(response?.unitList);
          setIntialUnitTypesList(response?.unitList);

          getAllRooms();
          setLoadingData(false);
        }
      }
    );
  }, []);

  const getAlUnitTypes = (query: object, offset: number, limit: number) => {
    setLoadingData(true);
    getAllUnitTypes(getModuleName(), offset, limit, query).then(
      (response: UnitTypeUiModelResponse | ErrorInfo) => {
        if (!isErrorInfo(response)) {
          setListCount(response?.count);
          setUnitTypesList(response?.unitList);
          setIntialUnitTypesList(response?.unitList);
          setLoadingData(false);
        }
      }
    );
  };
  const handleUpdateUnitType = (id: string, data: Partial<UnitTypeUiModel>) => {
    if (id) {
      const promise = updateUnitTypeData(id, data).then((response: UnitTypeUiModel | ErrorInfo) => {
        if (!isErrorInfo(response)) {
          getAlUnitTypes(searchQuery, offset, limit);
        } else {
          throw response;
        }
      });
      birdToast.promise(promise, {
        loadingMessage: 'Updating Unit Type...',
        successMessage: t(
          'UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.NOTIFICATIONS.UPDATE_UNIT_TYPE.MESSAGE'
        ),
        errorFailedMessage: t(
          'UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.NOTIFICATIONS.UPDATE_FAILED.TITLE'
        )
      });
    }
  };
  const handleNewUnitTypeSubmit = (unitTypeData: UnitTypeUiModel) => {
    addNewUnitType(unitTypeData).then((response: UnitTypeUiModel | ErrorInfo) => {
      if (isErrorInfo(response)) {
        if (response.status === 401 || response.status === 403) {
          birdToast.error(
            t('PROPERTY_MODULE.LIST_CONTAINER.NOTIFICATIONS.ADD_PROPERTY_PERMISSION.TITLE'),
            t('PROPERTY_MODULE.LIST_CONTAINER.NOTIFICATIONS.ADD_PROPERTY_PERMISSION.MESSAGE')
          );
        } else {
          birdToast.error(
            t('PROPERTY_MODULE.LIST_CONTAINER.NOTIFICATIONS.ADD_PROPERTY_FAILED.MESSAGE')
          );
        }
      } else {
        birdToast.success(
          t('PROPERTY_MODULE.LIST_CONTAINER.NOTIFICATIONS.ADD_PROPERTY_SUCCESS.MESSAGE')
        );
        setIntialUnitTypesList([...intialUnitTypesList, response]);
        setUnitTypesList([...intialUnitTypesList, response]);
        history.push(
          (APP_ROUTES.UNIT_TYPE_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH.replace(
            ':id',
            response.id as string
          )
        );
      }
    });
  };

  const getNewUnits = (offsetNumber: number) => {
    setOffset(offsetNumber);
    getAlUnitTypes(searchQuery, offsetNumber, limit);
  };

  return (
    <div className="flex flex-col items-start h-full min-h-[calc(100vh-45px)] bg-creams-100/20 px-4 md:px-8 py-6 ">
      <div className="flex items-center justify-between w-full mb-6">
        <h1 className="text-4xl font-recoleta font-semibold text-neutral-500">
          {t('UNIT_TYPE_MODULE.LIST_CONTAINER.TITLE')}
        </h1>
        <div className="flex flex-row gap-2">
          <Button size={ButtonSize.small} onClick={() => setFiltersOpen(!filtersOpen)}>
            <span>Filters</span>
          </Button>
          <Button size={ButtonSize.small} onClick={() => setShowAddModal(true)}>
            <span className="">Add Unit</span>
          </Button>
        </div>
      </div>

      <div
        className={`w-full overflow-hidden transition-all duration-300 ${
          filtersOpen ? 'max-h-[500px] mb-4' : 'max-h-0'
        }`}
      >
        <div className=" p-4 md:p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
            <div>
              <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1">
                Search All
              </label>
              <InputText
                data={{
                  value: unitTypeSearch.value,
                  placeholder: 'search Units Name & Id'
                }}
                config={{
                  maxRows: 1,
                  autoFocus: false
                }}
                eventHandlers={{
                  onChangeHandler: (value: string, isValid: boolean) => {
                    setUnitTypeSearch({ value, isValid });
                  }
                }}
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1">
                Room Name
              </label>
              <Select
                menuPortalTarget={document.body}
                options={roomsOptions}
                placeholder="All rooms"
                value={roomsOptions.find((o) => o.value === roomId) ?? null}
                isClearable
                className="w-full"
                onChange={(value: ValueType<{ value: string; label: string }, false>) => {
                  setRoomId(value ? value.value : '');
                }}
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1">
                Published
              </label>
              <Select
                placeholder="All"
                value={
                  publishedSelected !== undefined
                    ? publishedOptions.find((o) => o.value === publishedSelected) ?? null
                    : null
                }
                menuPortalTarget={document.body}
                isClearable
                options={publishedOptions}
                className="w-full"
                onChange={(value: ValueType<{ value: boolean; label: string }, false>) => {
                  setPublishedSelected(value ? value.value : undefined);
                }}
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1">
                Featured
              </label>
              <Select
                placeholder="All"
                value={
                  featuredSelected !== undefined
                    ? featuredOptions.find((o) => o.value === featuredSelected) ?? null
                    : null
                }
                isClearable
                options={featuredOptions}
                className="w-full"
                onChange={(value: ValueType<{ value: boolean; label: string }, false>) => {
                  setFeaturedSelected(value ? value.value : undefined);
                }}
                menuPortalTarget={document.body}
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1">
                Channel Manager
              </label>
              <Select
                options={channelManagerOptions}
                className="w-full"
                onChange={(value: ValueType<{ value: boolean; label: string }, false>) => {
                  setChannelManagerSelected(value ? value.value : undefined);
                }}
                placeholder="All"
                value={
                  channelManagerSelected !== undefined
                    ? channelManagerOptions.find((o) => o.value === channelManagerSelected) ?? null
                    : null
                }
                isClearable
                menuPortalTarget={document.body}
              />
            </div>
          </div>
          <div className="flex justify-end items-center gap-2 mt-4">
            <Button
              onClick={() => {
                if (
                  unitTypeSearch.value ||
                  roomId ||
                  featuredSelected !== undefined ||
                  publishedSelected !== undefined ||
                  channelManagerSelected !== undefined
                ) {
                  const searchValue = {} as any;
                  if (unitTypeSearch.value) {
                    searchValue.freeText = unitTypeSearch.value;
                  }
                  if (featuredSelected !== undefined) {
                    searchValue.isFeatured = featuredSelected;
                  }
                  if (publishedSelected !== undefined) {
                    searchValue.isListed = publishedSelected;
                  }
                  if (channelManagerSelected !== undefined) {
                    searchValue.isSynced = channelManagerSelected;
                  }
                  if (roomId) {
                    searchValue.unitId = roomId;
                  }
                  setSearchQuery(searchValue);
                  getAlUnitTypes(searchValue, offset, limit);
                }
              }}
              tracking={{
                action: 'search',
                category: 'unittypes',
                label: 'search-unitypes-create-reservation'
              }}
              size={isMobileView ? ButtonSize.full : ButtonSize.medium}
            >
              search
            </Button>
            <Button
              type={ButtonType.primaryInverted}
              onClick={() => {
                reInitialize();
                getAlUnitTypes({}, 1, limit);
              }}
              className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors text-sm font-medium"
            >
              Clear Filters
            </Button>
          </div>
        </div>
      </div>

      {loadingData ? (
        <LoadingData />
      ) : (
        <div className="w-full pb-8">
          {unitTypesList.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:mb-24">
              {unitTypesList?.map((unitType) => (
                <div
                  key={unitType.id}
                  className={cn(
                    `group bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden flex flex-col  ring-0 `,
                    {
                      'ring-primary-400 ring-2': unitType?.bookingMode === BookingMode.INSTANT,
                      'ring-secondary-400 ring-2': unitType.isListed
                    }
                  )}
                >
                  <div className="relative h-44 overflow-hidden">
                    <img
                      className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 ${
                        unitType.isListed ? '' : 'grayscale opacity-60'
                      }`}
                      alt="unit-type"
                      src={
                        unitType?.coverImage || `${PUBLIC_PATH}/assets/pngs/unit-type-default.png`
                      }
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                    <div className="absolute top-3 left-3 flex flex-row gap-4">
                      {unitType?.bookingMode === BookingMode.INSTANT && (
                        <div className="flex items-center gap-1.5 bg-primary-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-lg">
                          <OfflineBoltIcon className="text-sm" />
                          Instant
                        </div>
                      )}
                      {unitType.isFeatured && unitType.propertyName && (
                        <div className="bg-yellow-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg flex items-center gap-1">
                          <Star className="text-xs" /> FEATURED
                        </div>
                      )}
                    </div>
                    <div className="absolute top-3 right-3">
                      <OrangeSwitch
                        disabled={updatingUnit}
                        checked={unitType.isListed}
                        value={unitType.isListed}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          handleUpdateUnitType(unitType.id || '', {
                            isListed: event.target.checked
                          });
                        }}
                        name="isListed"
                        color="primary"
                        size="small"
                      />
                    </div>
                    <button
                      type="button"
                      className="absolute bottom-3 right-3 p-2 rounded-full bg-white/90 hover:bg-white shadow-lg transition-transform hover:scale-110"
                      onClick={(e) => {
                        unitType.propertyName
                          ? handleUpdateUnitType(unitType.id || '', {
                              isFeatured: unitType.isFeatured ? false : true
                            })
                          : e.preventDefault();
                      }}
                      disabled={!unitType.propertyName}
                    >
                      {!unitType.isFeatured && unitType.propertyName && (
                        <StarBorderOutlined className="text-lg text-gray-600 hover:text-yellow-500 transition-colors" />
                      )}
                      {unitType.isFeatured && unitType.propertyName && (
                        <Star className="text-lg text-yellow-500" />
                      )}
                      {!unitType.propertyName && <Star className="text-lg text-gray-300" />}
                    </button>
                  </div>
                  <div className="p-4 flex-1 flex flex-col">
                    {/* Title row */}
                    <div className="flex items-start justify-between gap-2 mb-1">
                      <h3
                        className={`text-2xl font-bold font-gilroy-bold leading-snug truncate ${
                          !unitType.name ? 'text-gray-300' : 'text-neutral-700'
                        }`}
                        title={unitType.name || ''}
                      >
                        {unitType.name}
                      </h3>
                      {!unitType.propertyName && (
                        <Tooltip title="Not assigned to a property">
                          <span className="inline-flex items-center gap-1 text-sm font-semibold text-red-500 bg-red-50 border border-red-100 px-1.5 py-0.5 rounded-full">
                            <WarningIcon style={{ fontSize: 12 }} />
                            Unassigned
                          </span>
                        </Tooltip>
                      )}
                    </div>

                    <div className="flex-1 mt-2 space-y-1.5">
                      <div className="flex gap-2 flex-row">
                        {unitType.area && (
                          <div className="flex items-center gap-1.5 min-w-0">
                            <svg
                              className="w-3.5 h-3.5 text-gray-400 flex-shrink-0"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              aria-hidden="true"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                            </svg>
                            <a
                              href={`${process.env.PUBLIC_URL}/properties/edit/${unitType.areaId}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-xl font-medium text-neutral-500 font-gilroy-medium hover:text-primary-600 truncate transition-colors"
                            >
                              {unitType.area} |
                            </a>
                          </div>
                        )}
                        {unitType.propertyName ? (
                          <a
                            href={`${process.env.PUBLIC_URL}/properties/edit/${unitType.propertyId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xl font-medium text-neutral-500 font-gilroy-medium hover:text-primary-600 truncate transition-colors"
                          >
                            {unitType.propertyName}
                          </a>
                        ) : null}
                      </div>

                      <div className="flex flex-row gap-2">
                        {/* Homeowner */}
                        <div className="flex items-center gap-1.5 min-w-0">
                          <svg
                            className="w-3.5 h-3.5 text-gray-400 flex-shrink-0"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span
                            className={`truncate text-lg font-medium ${
                              unitType.landlordUsername ? 'text-neutral-500' : 'text-gray-400'
                            }`}
                          >
                            {unitType.landlordUsername || 'No homeowner'}
                          </span>
                        </div>

                        {/* Channel Manager */}
                        <div className="flex items-center gap-1.5 min-w-0">
                          <OfflineBoltIcon
                            style={{ fontSize: 14 }}
                            className={unitType.cmId ? 'text-primary-500' : 'text-gray-300'}
                          />
                          {unitType.cmId ? (
                            <span className="text-xl font-medium text-neutral-500 truncate">
                              {unitType.cmId}
                            </span>
                          ) : (
                            <span className="text-gray-400  text-sm">Not synced</span>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Units tags */}
                    <div className="mt-3 flex flex-wrap gap-1">
                      {unitType.units && unitType.units.length > 0 ? (
                        <>
                          {unitType.units.slice(0, 3).map((unit) => (
                            <span
                              key={unit.unitId}
                              className="inline-flex items-center px-2 py-0.5 rounded-md text-base font-gilroy-medium font-medium bg-primary-50 text-primary-700 border border-primary-100"
                            >
                              <Tooltip title={unit.unitId}>{unit.shortName}</Tooltip>
                            </span>
                          ))}
                          {unitType.units.length > 3 && (
                            <span className="inline-flex items-center px-2 py-0.5 rounded-md text-sm font-medium bg-gray-100 text-gray-500">
                              +{unitType.units.length - 3}
                            </span>
                          )}
                        </>
                      ) : (
                        <span className="text-sm text-gray-400 italic">No units assigned</span>
                      )}
                    </div>

                    {/* Footer: price + stats + availability */}
                    <div className="mt-3 pt-3 border-t border-gray-100">
                      <div className="flex items-center justify-between gap-3">
                        <div className="flex-1 min-w-0 ">
                          <div className="mt-1.5 flex items-center gap-2.5 flex-wrap">
                            <div className="inline-flex items-center gap-1.5">
                              <span className="text-2xl leading-none font-bold text-neutral-600 font-gilroy-medium">
                                {formatPriceValue(unitType?.unitPrice)}
                              </span>
                              <span className="text-base font-semibold text-neutral-500">EGP</span>
                            </div>
                            <span className="text-gray-700 text-lg">•</span>
                            <div className="inline-flex items-center gap-1.5">
                              <span className="text-2xl leading-none font-bold text-primary-600 font-gilroy-medium">
                                {formatPriceValue(unitType?.unitPriceInUSD)}
                              </span>
                              <span className="text-base font-semibold text-primary-500">USD</span>
                            </div>
                            <div className="text-xl leading-none font-bold text-neutral-500 font-gilroy-medium">
                              /{' '}
                              {unitType?.reservationMode === ReservationMode.MONTHLY
                                ? 'monthly'
                                : 'nightly'}
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center gap-3 text-xs text-gray-500">
                          <Tooltip title="Units">
                            <div className="flex items-center gap-1">
                              <MeetingRoomIcon style={{ fontSize: 16 }} className="text-gray-400" />
                              <span className="font-medium text-neutral-500 font-gilroy-bold text-base">
                                {unitType?.units?.length || 0}
                              </span>
                            </div>
                          </Tooltip>
                          <Tooltip title="Amenities">
                            <div className="flex items-center gap-1">
                              <BathtubIcon style={{ fontSize: 16 }} className="text-gray-400" />
                              <span className="font-medium text-neutral-500 font-gilroy-bold text-base">
                                {unitType?.amenities?.length || 0}
                              </span>
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                      {unitType.availableFrom && (
                        <div className="mt-2 text-base px-2.5 py-1.5 rounded-lg bg-amber-50 text-amber-700 font-medium font-gilroy-medium border border-amber-100 flex items-center gap-1.5">
                          <svg
                            className="size-5 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                          Available {new Date(unitType.availableFrom).toLocaleDateString()}
                        </div>
                      )}
                    </div>
                    <div className="mt-4 flex gap-2">
                      <MIButton
                        fullWidth
                        variant="contained"
                        size="medium"
                        className="!bg-primary-500 !text-base !font-gilroy-medium hover:!bg-primary-600 !text-white !font-semibold"
                        onClick={() => {
                          window.open(
                            PUBLIC_PATH +
                              (
                                APP_ROUTES.UNIT_TYPE_MODULE.CHILDREN as RouteConfig
                              ).EDIT.FULL_PATH.replace(':id', unitType.id as string),
                            '_blank'
                          );
                        }}
                        startIcon={<EditIcon className="!text-base" />}
                      >
                        Edit
                      </MIButton>
                      <MIButton
                        fullWidth
                        variant="outlined"
                        size="medium"
                        className="!text-red-500 !border-red-200 hover:!bg-red-50 hover:!border-red-300 !font-semibold !text-base !font-gilroy-medium"
                        onClick={() => {
                          setShowDeleteModal(true);
                        }}
                        startIcon={<DeleteIcon className="!text-base" />}
                      >
                        Delete
                      </MIButton>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-16 text-gray-500">
              <img
                src={`${PUBLIC_PATH}/assets/jpeg/no-records.jpg`}
                alt="no-data"
                className="max-w-md w-full mb-4"
              />
              <p className="text-lg">No Data Available</p>
            </div>
          )}
        </div>
      )}

      <AddUnitTypeModal
        config={{ showModal: showAddModal }}
        eventHandlers={{
          closeHandler: () => {
            setShowAddModal(false);
          },
          addUnitTypeHandler: (unitType) => {
            setShowAddModal(false);
            handleNewUnitTypeSubmit(unitType);
          }
        }}
      />

      <DeleteUnitTypeModal
        config={{ showModal: showDeleteModal }}
        eventHandlers={{
          closeHandler: () => {
            setShowDeleteModal(false);
          }
        }}
      />
      {listCount > 0 && (
        <div className="md:fixed md:bottom-0 md:inset-x-0 mx-auto w-[90%] lg:w-[60%] flex justify-center items-center">
          <Pagination
            itemCounts={listCount}
            itemsPerPage={limit}
            offset={offset}
            handlePageChange={(val) => {
              getNewUnits(val);
            }}
            handleItemsPerPage={(itemsPerPage) => {
              setLimit(itemsPerPage);
              getAlUnitTypes(searchQuery, offset, itemsPerPage);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default connect()(UnitTypesListContainer);
